/* Butter Crunch PDP behaviors */
(function () {
  'use strict';

  /* Countdown: evergreen 2h timer persisted per visitor */
  document.querySelectorAll('[data-bc-countdown]').forEach(function (el) {
    var hours = parseFloat(el.dataset.bcCountdown || '2');
    var key = 'bc_count_end';
    var end = parseInt(sessionStorage.getItem(key) || '0', 10);
    if (!end || end < Date.now()) {
      end = Date.now() + hours * 3600 * 1000;
      sessionStorage.setItem(key, String(end));
    }
    var h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
    function tick() {
      var d = Math.max(0, end - Date.now());
      var hh = Math.floor(d / 3600000), mm = Math.floor(d % 3600000 / 60000), ss = Math.floor(d % 60000 / 1000);
      if (h) h.textContent = String(hh).padStart(2, '0');
      if (m) m.textContent = String(mm).padStart(2, '0');
      if (s) s.textContent = String(ss).padStart(2, '0');
    }
    tick();
    setInterval(tick, 1000);
  });

  /* Delivery estimate: today + N days, skip nothing (simple) */
  document.querySelectorAll('[data-bc-delivery-days]').forEach(function (el) {
    var days = parseInt(el.dataset.bcDeliveryDays || '3', 10);
    var d = new Date(Date.now() + days * 86400000);
    var fmt = d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    el.textContent = fmt;
  });

  /* Buy box: tier picker + gallery + ATC */
  document.querySelectorAll('[data-bc-buybox]').forEach(function (box) {
    var tiers = box.querySelectorAll('.bc-tier');
    var atcBtn = box.querySelector('[data-bc-atc]');
    var priceEl = box.querySelector('[data-bc-price]');
    var compareEl = box.querySelector('[data-bc-compare]');
    var stickyPrice = document.querySelector('[data-bc-sticky-price]');
    var ladder = box.querySelectorAll('.bc-giftladder__item');
    var errorEl = box.querySelector('[data-bc-atc-error]');

    /* colour picker: the pack tier decides HOW MANY bars, the swatches decide which */
    var colorsWrap = box.querySelector('[data-bc-colors]');
    var swatches = box.querySelectorAll('[data-bc-swatch]');
    var pickedEl = box.querySelector('[data-bc-picked]');
    var unitsEl = box.querySelector('[data-bc-units]');
    var colorsHint = box.querySelector('[data-bc-colors-hint]');
    var counts = [];
    var units = 1;

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }
    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg || '';
      errorEl.hidden = !msg;
    }
    function totalPicked() {
      return counts.reduce(function (a, b) { return a + b; }, 0);
    }
    function colorSummary() {
      var parts = [];
      counts.forEach(function (n, i) {
        if (n > 0) parts.push(swatches[i].dataset.name + (n > 1 ? ' x' + n : ''));
      });
      return parts.join(', ');
    }
    function spread(n) {
      /* default a multipack to an even mix — the offer copy promises mixed colours */
      counts = [];
      for (var i = 0; i < swatches.length; i++) counts.push(0);
      if (!swatches.length) return;
      for (var j = 0; j < n; j++) counts[j % swatches.length] += 1;
    }
    function renderColors() {
      var total = totalPicked();
      var single = units === 1;
      if (colorsWrap) {
        colorsWrap.classList.toggle('is-single', single);
        var titleEl = colorsWrap.querySelector('[data-bc-colors-title]');
        var wanted = single ? colorsWrap.dataset.titleOne : colorsWrap.dataset.titleMany;
        if (titleEl && wanted) titleEl.textContent = wanted;
      }
      swatches.forEach(function (sw, i) {
        var qtyEl = sw.querySelector('[data-bc-qty]');
        if (qtyEl) qtyEl.textContent = counts[i];
        sw.classList.toggle('is-picked', counts[i] > 0);
        var plus = sw.querySelector('[data-bc-plus]');
        var minus = sw.querySelector('[data-bc-minus]');
        if (plus) plus.disabled = total >= units;
        if (minus) minus.disabled = counts[i] === 0;
      });
      if (pickedEl) pickedEl.textContent = total;
      if (unitsEl) unitsEl.textContent = units;
      var short = units - total;
      if (colorsHint) {
        colorsHint.textContent = short > 0
          ? 'Pick ' + short + ' more to continue'
          : (single ? '' : 'Nice mix — ' + colorSummary());
      }
      if (atcBtn) atcBtn.classList.toggle('is-disabled', short > 0);
      if (short === 0) showError('');
    }
    function bump(i, delta) {
      var next = counts[i] + delta;
      if (next < 0) return;
      if (delta > 0 && totalPicked() >= units) {
        if (units === 1) { spread(0); counts[i] = 1; renderColors(); }
        return;
      }
      counts[i] = next;
      renderColors();
    }
    swatches.forEach(function (sw, i) {
      var chip = sw.querySelector('[data-bc-chip]');
      if (chip) {
        chip.addEventListener('click', function () {
          if (units === 1) { spread(0); counts[i] = 1; renderColors(); }
          else bump(i, 1);
        });
      }
      var plus = sw.querySelector('[data-bc-plus]');
      var minus = sw.querySelector('[data-bc-minus]');
      if (plus) plus.addEventListener('click', function () { bump(i, 1); });
      if (minus) minus.addEventListener('click', function () { bump(i, -1); });
    });

    function select(tier) {
      tiers.forEach(function (t) { t.classList.toggle('is-active', t === tier); });
      var price = parseInt(tier.dataset.price, 10);
      var compare = parseInt(tier.dataset.compare || '0', 10);
      if (priceEl) priceEl.textContent = money(price);
      if (compareEl) compareEl.textContent = compare > price ? money(compare) : '';
      if (stickyPrice) stickyPrice.textContent = money(price);
      var level = parseInt(tier.dataset.giftLevel || '0', 10);
      ladder.forEach(function (item, i) {
        var unlocked = i < level;
        item.classList.toggle('is-unlocked', unlocked);
        var lock = item.querySelector('.bc-lock');
        if (lock) lock.textContent = unlocked ? 'UNLOCKED' : 'Locked';
      });
      units = parseInt(tier.dataset.units || '1', 10) || 1;
      spread(units);
      renderColors();
      showError(tier.hasAttribute('data-unavailable')
        ? 'This pack is sold out right now — pick another size.'
        : '');
    }
    tiers.forEach(function (t) {
      t.addEventListener('click', function () { select(t); });
    });
    if (tiers.length) {
      var def = box.querySelector('.bc-tier[data-default]') || tiers[0];
      select(def);
    }

    /* gallery slider */
    var track = box.querySelector('[data-bc-track]');
    var dots = box.querySelectorAll('[data-bc-dots] span');
    var thumbs = box.querySelectorAll('[data-bc-thumbs] button');
    function setActive(i) {
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
      thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === i); });
    }
    if (track) {
      thumbs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var i = parseInt(btn.dataset.index, 10) || 0;
          track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
          setActive(i);
        });
      });
      var scrollTimer;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          setActive(Math.round(track.scrollLeft / track.clientWidth));
        }, 80);
      }, { passive: true });
    }

    /* add to cart */
    if (atcBtn) {
      var addUrl = box.dataset.cartAddUrl || '/cart/add';
      var cartUrl = box.dataset.cartUrl || '/cart';
      var propName = box.dataset.colorsProperty || 'Colors';

      atcBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var active = box.querySelector('.bc-tier.is-active');
        if (!active) { showError('Choose a pack size first.'); return; }

        var variantId = parseInt(active.dataset.variantId || '', 10);
        if (!variantId) {
          /* never fail silently — this is what made the old button look dead */
          showError('This option is not available to buy yet. Please pick another pack.');
          return;
        }
        if (swatches.length && totalPicked() !== units) {
          showError('Pick ' + (units - totalPicked()) + ' more color' + (units - totalPicked() === 1 ? '' : 's') + ' to continue.');
          if (colorsWrap) colorsWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }

        var item = { id: variantId, quantity: parseInt(active.dataset.qty || '1', 10) || 1 };
        var summary = colorSummary();
        if (summary) {
          item.properties = {};
          item.properties[propName] = summary;
        }

        showError('');
        atcBtn.disabled = true;
        atcBtn.textContent = 'Adding…';
        fetch(addUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [item] })
        }).then(function (r) {
          /* Shopify sometimes answers with an HTML challenge/redirect page instead of
             JSON. Parsing that blind leaks "Unexpected token '<'" into the buy box, so
             fall back to a message a shopper can act on. */
          return r.text().then(function (body) {
            var data = null;
            try { data = JSON.parse(body); } catch (e) { /* not JSON */ }
            if (!data) {
              if (r.ok) return {};
              throw new Error('Could not add to cart. Please refresh and try again.');
            }
            if (!r.ok) throw new Error(data.description || data.message || 'Could not add to cart. Please try again.');
            return data;
          });
        }).then(function () {
          window.location.href = cartUrl;
        }).catch(function (err) {
          atcBtn.disabled = false;
          atcBtn.textContent = atcBtn.dataset.label || 'Add to Cart';
          showError(err.message || 'Could not add to cart. Please try again.');
        });
      });
    }
  });

  /* Purchase-type toggle: cosmetic (one-time only store, subscribe tab shows note) */
  document.querySelectorAll('[data-bc-toggle]').forEach(function (tog) {
    var btns = tog.querySelectorAll('button');
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        btns.forEach(function (x) { x.classList.toggle('is-active', x === b); });
      });
    });
  });

  /* Sticky mobile ATC: show once buy box scrolled past */
  var sticky = document.querySelector('.bc-sticky');
  var buybox = document.querySelector('[data-bc-buybox]');
  if (sticky && buybox && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 });
    io.observe(buybox);
    sticky.querySelector('.bc-cta') && sticky.querySelector('.bc-cta').addEventListener('click', function (e) {
      e.preventDefault();
      buybox.scrollIntoView({ behavior: 'smooth' });
    });
  }
})();
